
<div class="modal-signup modal-content">

  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Results

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-5px">


        <div class="modal-body padding-top-0px  padding-right-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-3 padding-right-0px bk-color-light2">
              <div class="row margin-top-10">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <img class="img-circle-50" src="dummy.jpg" onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <label class="margin-bottom-0px font-size-16px color-Assign">Surya</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">Male,34</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">GG1I/2092</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Order No</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">GG2-L17007092</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Order Date</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">17-09-2020</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Lab</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">Andrology</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <div class="col-md-9 padding-left-0px">

              <div>
                <div>
                  <form class="form " novalidate="" #f="ngForm">
                    <div class="card margin-top-10">
                      <div class="card-body margin-left-zero padding-left-0px padding-right-0px ">
                        <div class="row margin-left-auto">
                          <div class="col-md-12 padding-l-0px">
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-3 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px">Effective Order Date</label>
                                  </div>
                                  <div class="col-md-4">
                                    <input type="text" class="form-control" placeholder="Collection Date">

                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-3 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px">Entered By</label>
                                  </div>
                                  <div class="col-md-4">
                                    <input type="text" class="form-control" placeholder="Collection Date">

                                  </div>

                                </div>

                              </div>
                            </div>
                            <div class="row">
                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                <div class="row">
                                  <div class="col-md-3 text-align-right padding-left-0px">
                                    <label for="firstName" class="margin-bottom-0px margin-top-5px">Remarks</label>
                                  </div>
                                  <div class="col-md-4">
                                    <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"></textarea>


                                  </div>

                                </div>

                              </div>
                            </div>




                          </div>
                        </div>
                      </div>
                      <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                        <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
                        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                      </div>
                    </div>
                  </form>
                </div>

              </div>
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
</div>
